
import { useRouter, useRoute } from 'vue-router';
import {
  defineComponent, computed, ref, Ref, inject,
} from 'vue';
// eslint-disable-next-line import/no-unresolved
import { useResizeObserver } from '@vueuse/core';
import { descriptionWithLink } from '@/helpers/utils';
import { useProfileStore } from '@/modules/profile/store/profileStore';
import AppHeaderUploadProgress from './AppHeaderUploadProgress.vue';
import { useMainStore } from '@/store/mainStore';

export default defineComponent({
  components: {
    AppHeaderUploadProgress,
  },
  props: {
    customTitle: { type: String, default: '' },
    countPadding: { type: Boolean, default: false },
  },
  setup(props) {
    const router = useRouter();
    const route = useRoute();
    const profileStore = useProfileStore();
    const mainStore = useMainStore();
    // eslint-disable-next-line @typescript-eslint/ban-types
    const $localize = inject('$localize') as Function;

    const header: Ref<HTMLElement | null> = ref(null);
    const spacerHeight: Ref<string> = ref('');

    const title = computed(() => $localize(route.meta?.title));
    const stepBackTo = computed(() => route.meta?.stepBackTo);
    const isCancel = computed(() => route.meta?.cancel);
    const isHome = computed(() => route.meta?.home);

    const backText = computed(() => {
      if (isCancel.value) {
        return 'Cancel';
      }
      if (isHome.value) {
        return 'Home';
      }
      if (stepBackTo.value) {
        return 'Back';
      }
      return '';
    });

    function resetBufferProfile() {
      if (isCancel.value) {
        profileStore.resetBufferProfile();
      }
    }

    function handleStepBack() {
      resetBufferProfile();
      if (!stepBackTo.value) {
        router.back();
      } else {
        router.push(stepBackTo.value as string);
      }
    }

    function setSpacerHeight() {
      if (props.countPadding) {
        spacerHeight.value = `${header.value?.offsetHeight}px`;
      } else {
        // 20 it`s application top padding
        spacerHeight.value = `${header.value?.offsetHeight ? header.value.offsetHeight - 20 : 0}px`;
      }
    }

    useResizeObserver(header, () => {
      setSpacerHeight();
    });

    return {
      backText,
      stepBackTo,
      header,
      spacerHeight,
      router,
      isCancel,
      title,
      mainStore,
      handleStepBack,
      setSpacerHeight,
      descriptionWithLink,
    };
  },
});
